import React, { useState, useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import ComputedDataContext from './ComputedDataContext'
import DateContext from './DateContext'
import PriceContext from './PriceContext'
import ThresholdContext from './ThresholdContext'
import { soilingAverageRate } from './utils'

const CurrentCentralContext = React.createContext({})
CurrentCentralContext.displayName = 'CurrentCentralContext'
export default CurrentCentralContext

const CurrentCentralStore = ({ children }) => {
  const { centralsData, centralsMetaData } = useContext(ComputedDataContext)
  const { get: dates, set: setDates } = useContext(DateContext)
  const { get: price } = useContext(PriceContext)
  const { get: threshold } = useContext(ThresholdContext)
  const [get, set] = useState({})
  const [data, setData] = useState({})
  const [filteredData, setFilteredData] = useState({})
  const [notGenerated, setNotGenerated] = useState(0)
  const [daysToUmbral, setDaysToUmbral] = useState(0)
  const [daySoilingAverageRate, setDaySoilingAverageRate] = useState(0)
  const [notGeneratedValorization, setNotGeneratedValorization] = useState(0)
  useEffect(() => {
    if (!get.id) return
    if (!centralsMetaData[get.id]) return
    if (!centralsData[get.id]) return

    if (data.id === get.id
      && centralsData[get.id].cleaning.length === data.cleaning.length
    ) return
    const { fullInterval } = centralsMetaData[get.id]
    setDates(fullInterval)
    setData({
      data: { ...centralsData[get.id] },
      ...centralsData[get.id],
      ...centralsMetaData[get.id],
      id: get.id,
    })
  }, [centralsData, centralsMetaData, data, data.id, get.id, setDates])
  useEffect(() => {
    if (!data.data) return
    const { start, end } = dates
    const {
      cleaning = [],
      power = [],
      soiling = [],
      soilingPercent = [],
      rain = [],
      soilingSensor = [],
      soilingSensor2 = [],
    } = data.data
    setFilteredData(
      {
        rain: rain.filter(({ date: d }) => d.isBetween(start, end, undefined, '(]')),
        soilingSensor: soilingSensor.filter(({ date: d }) => d.isBetween(start, end, undefined, '(]')),
        soilingSensor2: soilingSensor2.filter(({ date: d }) => d.isBetween(start, end, undefined, '(]')),
        cleaning: cleaning.filter(({ date: d }) => d.isBetween(start, end, undefined, '(]')),
        power: power.filter(({ date: d }) => d.isBetween(start, end, undefined, '(]')),
        soiling: soiling.filter(({ date: d }) => d.isBetween(start, end, undefined, '(]')),
        soilingPercent: soilingPercent.filter(({ date: d }) => d.isBetween(start, end, undefined, '(]')),
      },
    )
  }, [data.data, dates])


  useEffect(() => {
    if (!filteredData) return
    if (!filteredData.soiling) return
    const notGeneratedLocal = filteredData.soiling.reduce((sum, { data: d }) => {
      return sum + d;
    }, 0);
    setNotGenerated(notGeneratedLocal)
  }, [filteredData])


  // useEffect(() => {
  //   if (!filteredData) return
  //   if (!filteredData.soilingPercent) return

  //   setDaySoilingAverageRate(soilingAverageRate(filteredData.soilingPercent))
  // }, [filteredData])

  useEffect(() => {
    if (!get) return
    if (!get.daySoilingAverageRate) return

    setDaySoilingAverageRate(get.daySoilingAverageRate)
  }, [get])

  useEffect(() => {
    setNotGeneratedValorization(notGenerated * price)
  }, [notGenerated, price])

  useEffect(() => {
    const { currentSoilingRate = undefined } = get
    if (!currentSoilingRate) return
    if (+threshold <= +currentSoilingRate) {
      setDaysToUmbral(0)
      return
    }
    setDaysToUmbral((threshold - currentSoilingRate) / daySoilingAverageRate)
  }, [daySoilingAverageRate, get, threshold])

  return (
    <CurrentCentralContext.Provider value={{
      get,
      set,
      data,
      setData,
      filteredData,
      metaData: {
        notGenerated,
        notGeneratedValorization,
        daySoilingAverageRate,
        daysToUmbral,
      },
    }}
    >
      {children}
    </CurrentCentralContext.Provider>
  )
}
CurrentCentralStore.propTypes = { children: PropTypes.node.isRequired }
export { CurrentCentralStore }
